import { render, staticRenderFns } from "./BrandAggregatePage.vue?vue&type=template&id=8cff16f8&scoped=true&"
import script from "./BrandAggregatePage.vue?vue&type=script&lang=js&"
export * from "./BrandAggregatePage.vue?vue&type=script&lang=js&"
import style0 from "./BrandAggregatePage.vue?vue&type=style&index=0&id=8cff16f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cff16f8",
  null
  
)

export default component.exports